<template>
  <div class="main-template">
    <!-- User Profile -->
    <UserProfile
      v-show="profile && !changePassword"
      @show-change-password="openChangePassword"
      >
    </UserProfile>
    <!-- Change password -->
    <transition name="fade-in-right">
      <ChangePassword
        v-if="changePassword && !profile"
        @close-change-password="openProfile"
        >
      </ChangePassword>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import ChangePassword from '@/components/profile/ChangePassword.vue'
import UserProfile from '@/components/profile/UserProfile.vue'

@Component({
  name: 'Profile',
  components: {
    UserProfile,
    ChangePassword
  }
})
class Profile extends Vue {
  profile: boolean = true
  changePassword: boolean = false

  openChangePassword () {
    this.hideProfile()
    this.showChangePassword()
  }

  openProfile () {
    this.hideChangePassword()
    setTimeout(() => {
      this.showProfile()
    }, 250)
  }

  showProfile () {
    this.profile = true
  }

  hideProfile () {
    this.profile = false
  }

  showChangePassword () {
    this.changePassword = true
  }

  hideChangePassword () {
    this.changePassword = false
  }
}
export default Profile
</script>

<style scoped>
.main-template {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
